/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
 
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-console */
/* eslint-disable no-secrets/no-secrets */

import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useEffect, useCallback, useContext, useState } from 'react';
import { TwiaBillingService }  from 'ent-capability-policybilling';
import { useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { IntlContext, TranslatorContext } from "@jutro/locale";
import { LocaleService } from 'gw-portals-i18n-react';
import _ from 'lodash';
import appConfig from 'app-config';
import DuplicatePaymentPopup  from '../DuplicatePaymentPopup/DuplicatePaymentPopup';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import messages from './MakeAPaymentComponent.messages';
import metadata from './MakeAPaymentComponent.metadata.json5';
import styles from './MakeAPaymentComponent.module.scss';

function MakeAPayment(props) {
    const { 
        payFrom,
        policyNumber,
        offer, 
        bindData, 
        authHeader, 
        paymentInstrument,
        onSelectedInstrumentChange ,  // prop from parent
        paymentInstruments, // prop from parent
        paymentPlan, // get the value from parent (billingSummary)
        manualAmountToPay, // comes as a prop from parent === same as baseAmount
        updateManualAmount,
        currency, // prop from parent
        calcFees,
        setCalcFees,
        invoiceSummary, // invoice screen
        originalPaymentAmounts, // Original Outstanding on all selected 
        originalPaymentDueAmounts,
        selectedInvoicesForPayment, // invoice screen        
        onResolve,
        onReject,
        onAfterClose,
        onMakePayment,
        history
    } = props;

    const translator = useContext(TranslatorContext);
    const intlContext = useContext(IntlContext);
    const [loading, setLoading] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState({});
    const [baseAmount, setBaseAmount] = useState({});
    // const [paymentPlan, setPaymentPlan] = useState({});
    const [manualEntry, setManualEntry] = useState(false);
    const [feePercent, setFeePercent] = useState({});
    const [aciFee, setAciFee] = useState({});
    const [aciTotal, setAciTotal ] = useState({});
    const [disablePayNow, setDisablePayNow] = useState(false);
    // const [overrideDupPayment, setOverrideDupPayment] = useState(false);
    const { showAlert, showModal } = useModal();

     const generateModalErrorOrWarning = useCallback((messageHeader, messageDescription, statusType, withArgs) => {
         showAlert({
            title: translator(messageHeader),
            message: _.isEmpty(withArgs) || _.isUndefined(withArgs) ? translator(messageDescription) : translator(messageDescription, withArgs),
            status: statusType,
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        });
    }, [showAlert, translator]);

    const updateAmount= useCallback(() => {
         setPaymentAmount(manualAmountToPay?.amount);
    },[manualAmountToPay?.amount]);

    const setCalcTBD = useCallback(() => {
        setFeePercent(translator(messages.tbd));
        setAciFee(translator(messages.tbd));
        setAciTotal(translator(messages.tbd));
     }, [translator]);
 
     const updateFeeCalculator = useCallback(() => {
         if (!_.isEmpty(paymentInstrument) && !_.isNil(manualAmountToPay?.amount)){
            const piPublicID = paymentInstrument.publicID;
            const {amount} = manualAmountToPay;
            const policy = policyNumber;
    
            if (piPublicID && amount && policy && !_.isNaN(amount)) {
                 console.log(`updating fees for payment instrument public ID ${piPublicID}, amount ${amount}`);
                 setLoading(true);
               
                const totalAmount = {amount: parseFloat(amount).toFixed(2), currency};
    
                TwiaBillingService.getACICardFee(piPublicID, policy, totalAmount, authHeader)
                .then((fee) => {
                    setFeePercent(`${fee.feeRate}%`);
                    setAciFee({amount: fee.feeAmount});
                    setAciTotal(fee.totalAmount);
                    setPaymentAmount(fee);
                    setLoading(false);
                }, (errorResp) => {
                    console.log(errorResp);
                    setLoading(false);
                    setCalcTBD();
                  
                    generateModalErrorOrWarning(messages.confirmationMessage, messages.errorInProcessingPayment, 'error');
                });
            } else {
                setCalcTBD();
                setLoading(false);
            }
         }
       
     }, [authHeader, currency, generateModalErrorOrWarning, manualAmountToPay, paymentInstrument, policyNumber, setCalcTBD]);

     const  determineBaseAmountSource = useCallback(() =>  {
        let retAmount;
        if (payFrom === 'invoices') {
            retAmount = manualAmountToPay?.amount;
        } else if (payFrom === 'offers') {
           retAmount = _.get(bindData, 'customerPaymentDetails_TWIA.amount');
        } else {
            retAmount = 0.00;
        }
        return retAmount;
     }, [bindData, manualAmountToPay?.amount, payFrom])

    const getAmountValue = useCallback(() => ({
            "currency": currency,  
            "amount": determineBaseAmountSource()
        }), [currency, determineBaseAmountSource]);


    // After coming back from the confirmation popup we redirect to BillingSummary Page
    const onClickOk = useCallback(() =>{
        history.replace(`/billing-summary?payInvoices=true&policyNumber=${policyNumber}`);
        window.location.reload();
        }, [history, policyNumber]);

    const cancelPayment = (() =>{
        // 2025-01-31 - Debra Frum - DE18232 - Feature Testing_CE-TWIA: 'Cancel' button on Offer Details page 
        // is not redirecting user to My Summary screen
        if (payFrom === 'offers') {
            history.push('/home');
        } else {
            // Invoices need to redirect to BillingSummary screen with the correct PolicyNumber
            history.replace(`/billing-summary?payInvoices=true&policyNumber=${policyNumber}`);
            window.location.reload();
        }
    });

    const payInvoices = useCallback((evt, overrideDuplicatePayment) => {

        if( payFrom=== "offers"){
            onMakePayment();
            return;
        }
            
           // overrideDuplicatePayment 
            if (_.isUndefined(overrideDuplicatePayment)){
                 // We come back from duplicate payment popup     
                overrideDuplicatePayment = false;
            }
            
            TwiaBillingService.makePolicyPayment(paymentInstrument?.token, policyNumber, {amount: manualAmountToPay.amount}, overrideDuplicatePayment, authHeader).then((paymentDetails) => {
                if (paymentDetails.isPaymentExistInACI && paymentDetails.lastPaymentDate && overrideDuplicatePayment === false) {
                    // Give the user the chance to cancel the duplicate payment. Show the Duplicate Payment popup
                    const componentProps = {
                        paymentDetails,
                        isOpen: true,
                        onResolve,
                        currency,
                        onAfterClose,
                        payInvoices // function moved to parent and then propped back to child
                    };

                    // eslint-disable-next-line react/react-in-jsx-scope
                    showModal(<DuplicatePaymentPopup {...componentProps} />);
                    setDisablePayNow(true);
                } else {
                    // allow the user to proceed further
                    const componentProps = {
                        paymentDetails,
                        onClickOk,
                        onResolve,
                        onReject,
                        onAfterClose,
                        currency
                    }
                    // eslint-disable-next-line react/react-in-jsx-scope
                    showModal( <ConfirmationPopup {...componentProps} />);
                }
                // if (paymentInstrument.singleUse) {
                //     $scope.paymentInstruments = paymentInstruments.filter(item => item.token !== paymentInstrument.token);
                //     $stateParams.newPI = null;
                // }
            }).catch(e => {
                // US12929 - CE - Payment Integration
                setLoading(false);
                setDisablePayNow(true);
                const errorCode = _.get(e, 'data.appErrorCode');
                if (errorCode === 10007) {
                    // DE12503 - ACI undergoing maintenance - Exception Handling
                    generateModalErrorOrWarning(messages.paymentSystemUnavailable, messages.paymentSystemUnavailbleBody, 'error');
                } else if (errorCode === 10071) {
                    // US12929 declined error
                    generateModalErrorOrWarning(messages.cardDeclinedTitle, messages.cardDeclinedBody, 'error');
                } else if (errorCode === 10073) {
                    // US12929 duplicate error
                    const {amount} = manualAmountToPay;
                    // const message = {
                    //     key: messages.duplicatePaymentNotProcessedBody,
                    //     args: {amount: {amount}}
                    // };
                    generateModalErrorOrWarning(messages.DuplicatePaymentPopup, messages.duplicatePaymentNotProcessedBody, 'error', {amount: {amount}});
                } else if (errorCode === 10080) {
                    // US29148 redirect on throttle to stop any javascript 
                    window.location.href =  appConfig.twiaerrorPageApplication;                
                } else {
                    // US12929 general error
                    generateModalErrorOrWarning(messages.unableToCompletePaymentTitle, messages.unableToCompleteBody, 'error');
                }
            });
            // .finally(() => {
            
            //         history.push('/billing-summary');         
            //         updateState({});
                  
            // }
            // );
        }, [authHeader, currency, generateModalErrorOrWarning, manualAmountToPay, onAfterClose, onClickOk, onMakePayment, onReject, onResolve, payFrom, paymentInstrument?.token, policyNumber, showModal]);
        
    const refreshSummaryTable = useCallback(lookupPI => {
        const amount = getAmountValue();
        setLoading(true);

        if (payFrom === "invoices"){
           updateFeeCalculator()
           setLoading(false);
        }
        else {
            const  uw = _.get(bindData, 'customerPaymentDetails_TWIA.uwcompany');
            const product = _.get(offer, 'productCodeIdentifier_TWIA'); // Homeowners

            TwiaBillingService.getACICardFeeForOffer(lookupPI.publicID, product, amount, uw, authHeader)
            .then(fee => {
                setPaymentAmount(fee);
                setFeePercent(`${fee.feeRate}%`);
                setAciFee({amount: fee.feeAmount});
                setAciTotal(fee.totalAmount);
            }).finally(() => {
                setLoading(false);
                setCalcFees(false);
            });
        }
        
    }, [authHeader, bindData, getAmountValue, offer, payFrom, setCalcFees, updateFeeCalculator]);


    useEffect(() => {
        LocaleService.register();
        if (!_.isEmpty(manualAmountToPay?.amount)){
            updateAmount(manualAmountToPay);
        }
        ;
        if (payFrom === 'invoices'){
            setBaseAmount(manualAmountToPay);
           // updateManualAmount( manualAmountToPay);
            // setPaymentPlan(_.get(bindData, 'bindData.selectedPaymentPlan'));
        } else if (payFrom === 'offers'){
            setBaseAmount(manualAmountToPay);
            // setBaseAmount( _.get(bindData, 'customerPaymentDetails_TWIA.amount'));
            // setPaymentPlan(_.get(bindData, 'bindData.selectedPaymentPlan'));
           // paymentInstrument && refreshSummaryTable(paymentInstrument);
        }
       
        !_.isEmpty(paymentInstrument) && refreshSummaryTable(paymentInstrument);
        
    }, [manualAmountToPay, payFrom, paymentInstrument, refreshSummaryTable, updateAmount]);

    const disableCriteriaForPayNow = useCallback(() =>{
        if (payFrom === "invoices"){
            return  _.isEmpty(paymentPlan)
            || _.isNil(getAmountValue().amount) ||
          getAmountValue()?.amount === 0 || selectedInvoicesForPayment.length === 0
          || getAmountValue()?.amount > originalPaymentAmounts
          || getAmountValue()?.amount > 0 && getAmountValue()?.amount < originalPaymentDueAmounts
            || _.isEmpty(paymentInstrument)
        }
        if (payFrom === 'offers'){
            // 2025-01-10 - Debra Frum - US25427 - CE - Make a Payment on Offer Details
            // Must pay at least the downpayment amount
            return  _.isEmpty(paymentPlan)
            || _.isNil(getAmountValue().amount) ||  getAmountValue()?.amount === 0         
            || getAmountValue()?.amount <  _.get(bindData, 'customerPaymentDetails_TWIA.minimumAmount')
            || getAmountValue()?.amount >  _.get(bindData, 'paymentPlans[0].total.amount')
            || _.isEmpty(paymentInstrument)
        }
        return true;
    }, [bindData, getAmountValue, originalPaymentAmounts, originalPaymentDueAmounts, payFrom, paymentInstrument, paymentPlan, selectedInvoicesForPayment?.length]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const formatCurrency = useCallback(amount => 
        
        _.get(amount, 'amount') === undefined ||  _.get(amount, 'amount')=== null  ? translator(messages.tbd)
            : intlContext.formatNumber(amount.amount, {
                style: 'currency',
                currency: _.get(amount, 'currency')
            }) );

    const formatFee = useCallback(() =>{
         const data= _.get(paymentAmount, 'totalAmount') === undefined || _.get(paymentAmount, 'totalAmount') === null ?
    translator(messages.emptyAmount)
            :  formatCurrency({
                currency: paymentAmount.totalAmount.currency,
                amount: paymentAmount.feeAmount
            });
            return data;
        }, [formatCurrency, paymentAmount, translator]);

    const overrideProps = {
        makePaymentLoader: {
            visible: loading
        },
        makePaymentSummaryGrid: {
            visible: true
        },
        twiaAmount: { 
            content: formatCurrency(baseAmount)
        },
        totalAmount: {
            content: formatCurrency(paymentAmount.totalAmount)
        },
        vendorFee: {
            content: formatFee() 
        },
        vendorFeeLabel: {
            content: _.get(paymentAmount, 'feeRate') === undefined || _.get(paymentAmount, 'feeRate') === null  ?
            translator(messages.vendorFee): translator(messages.vendorFeeWithRate, {feeRate: paymentAmount.feeRate}) 
        },
        makePaymentButton: {
            disabled: disableCriteriaForPayNow()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            payInvoices,
            cancelPayment,
            onMakePayment
        }
    };

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

export default MakeAPayment;
